import { type App, GetAbsencesParams } from "@pentacode/core";
import { absencesKey } from "../all/calendar.queries";

export function employeeAbsencesQuery(app: App, employeeId: number) {
    return {
        queryKey: [...absencesKey, "employee", employeeId] as const,
        queryFn: ({ signal }: { signal: AbortSignal }) =>
            app.api.getAbsences(new GetAbsencesParams({ employee: [employeeId] }), { signal }),
    };
}
